<app-web-header />
<main class="main-content">
  <router-outlet />
</main>
<app-web-footer />
